import { createAsyncThunk, createAction } from '@reduxjs/toolkit';

import * as api from './api';
import {
  CANCEL_RECURLY_SUBSCRIPTION,
  FETCH_AUTOREFILL_STATUS,
  FETCH_RECURLY_SUBSCRIPTIONS,
  RESET_SUBSCRIPTIONS_REDUCER,
  UPDATE_AUTOREFILL_STATUS,
} from './types';

export const fetchSubscriptions = createAsyncThunk(
  FETCH_RECURLY_SUBSCRIPTIONS,
  () => api.retrieveSubscriptions(),
);

export const cancelSubscription = createAsyncThunk(
  CANCEL_RECURLY_SUBSCRIPTION,
  (id: string) => api.cancelSubscription(id),
);

export const resetSubscriptionsReducer = createAction(RESET_SUBSCRIPTIONS_REDUCER);

export const fetchAutoTopupStatus = createAsyncThunk(
  FETCH_AUTOREFILL_STATUS,
  () => api.getAutoTopup(),
);

export const updateAutoTopupStatus = createAsyncThunk(
  UPDATE_AUTOREFILL_STATUS,
  (value: boolean) => api.setAutoTopup({ value }),
);
